module.exports = __webpack_public_path__ + "0f90477c408eda6dc5d321bf64c5cc1b.svg";